import { SiteHeader, SiteFooter } from "./SiteLayout";
import { useSiteContent, usePageMeta } from "./siteContent";
import SiteSections from "./SiteSections";

export default function SiteTrusted() {
  const site = useSiteContent();
  usePageMeta("People We Trust | Wales Event Medical Services",
    "Trusted partner companies we work alongside at events — security, catering and more, recommended by Wales Event Medical Services.", "", "trusted", "noindex, nofollow");
  return (
    <div className="site-font bg-[#0B0F14]" data-testid="site-trusted">
      <SiteHeader />
      <SiteSections sections={site.page_sections.trusted} services={site.services_catalog} contact={site.contact_info} />
      <SiteFooter />
    </div>
  );
}
